import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ScoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"score"}/>
}
